export const STAND_ALONE = 'STAND_ALONE';
export const ONE_WAY = 'ONE_WAY';
export const ROUND_TRIP = 'ROUND_TRIP';
